import { runActions } from "../action";
import { IDecorator } from "../types";
import filterTool from "../util/filterTool";
import { Decorator } from "./decorator";

export class ListDecorator extends Decorator implements IDecorator {
    public static NAME: string = "list";

    // 

    /**
     * 获取当前对象实例
     * @returns 
     */
    getInstance() {
        return new ListDecorator();
    }

    /**
     * 1. 开始初始化
     */
    beforeInit() {
        this.addProp("datas", this.nmis!.currentData.source);

        this.addEvent("click", (data) => {
            const actions = this.getEventActions('click');
            if (filterTool.isNull(actions)) {
                return;
            }
            runActions(actions, Object.assign(this.fromJS(data), this.nmis!.openData), this.nmis!.componentIdMap, this.nmis)
        })
    }

    /**
     * 2. 初始化完成
     */
    inited() {

    }


}